import config from 'config'
import DashboardPopup from 'modules/dashboard/DashboardPopup/DashboardPopup'
import React from 'react'
import { Elements, StripeProvider } from 'react-stripe-elements'
import CheckoutForm from './CheckoutForm'

const FAKE_PLAN = {
  name: 'Plan'
}

const FAKE_PRODUCT = {
  name: 'Product'
}
export default class CheckoutFormPopup extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      stripe: null
    }
  }

  _setStripe () {
    this.setState({
      stripe: window.Stripe(config.stripeAPIKey)
    })
  }

  componentDidMount () {
    if (window.Stripe) {
      this.setState({
        stripe: window.Stripe(config.stripeAPIKey)
      })
    } else {
      document.querySelector('#stripe-js').addEventListener('load', this._setStripe.bind(this))
    }
  }

  componentWillUnmount () {
    document.querySelector('#stripe-js').removeEventListener('load', this._setStripe.bind(this))
  }

  render () {
    return (
      <StripeProvider stripe={this.state.stripe}>
        <Elements>
          <DashboardPopup onCancel={this.props.onCancel} height='auto' width='auto'>
            <CheckoutForm
              plan={this.props.plan}
              parent={this.props.parent}
              product={this.props.product}
              handleStripeToken={this.props.handleStripeToken}
              onSuccess={this.props.onSuccess.bind(this)}
              onCancel={this.props.onCancel}
              // onCancel={this.onCheckoutFormCancelled.bind(this)}
              subscription={this.props.subscription}
              getDiscount={this.props.getDiscount}
            />
          </DashboardPopup>
        </Elements>
      </StripeProvider>
    )
  }
}
